export default __webpack_public_path__ + "static/media/video-1.4959780f.mp4";